import { Pipe, PipeTransform } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CommonUtilty } from 'app';

@Pipe({
  name: 'filterSortGridData'
})
export class FilterSortGridDataPipe implements PipeTransform {

  constructor(private commonUtilty: CommonUtilty){

  }

  transform(list:any = [],operationType, filterKey, value, sortName, sortValue): unknown {
    if(operationType == 'FILTER'){
      if(value && filterKey)
        return list.filter(item => (item.controls[filterKey] && item.controls[filterKey].value) ? item.controls[filterKey].value.toLowerCase().includes(value.toLowerCase()) : []);
      else
      return list;
    }
    else if(operationType == 'SORT'){
      if (sortName && sortValue) {
        let orderBy = sortValue === 'ascend' ? 'asc' : 'desc';
        return this.sortObject(sortName, list, orderBy)
      } else {
        return list;
      }
    }else{
      return list
    }
  }
  
  /*sortFormArray(list, sortName) {
    const formArray = list.get(sortName) as FormArray;
    const sortedFormArray = formArray.controls
      .map((control, i) => {
        return {
          control,
          value: control.value,
          index: i
        };
      })
      .sort((a, b) => {
        if (a.value < b.value) {
          return -1;
        } else if (a.value > b.value) {
          return 1;
        } else {
          return 0;
        }
      });

    // remove all the controls from the formArray
    formArray.clear();

    // add the sorted controls back to the formArray
    sortedFormArray.forEach(({ control }) => {
      formArray.push(control);
    });
    return formArray;
  }*/

  sortObject(sortKey, list, orderBy){
    if (list && Array.isArray(list) && list.length > 0) {
      let sortedList =  list.sort(this.compareValues(sortKey, orderBy))
      return sortedList;
  }
  else {
      return list
  }
  }

  compareValues(key, order) {
    return function (a, b) {
        if (!a['controls'].hasOwnProperty(key) || !b['controls'].hasOwnProperty(key)) {
            // property doesn't exist on either object
            return 0;
        }

        const varA = (typeof  a['controls'][key]['value']=== 'string') ?
             a['controls'][key]['value'].toUpperCase() :  a['controls'][key]['value'];
        const varB = (typeof b['controls'][key]['value'] === 'string') ?
            b['controls'][key]['value'].toUpperCase() : b['controls'][key]['value'];

        let comparison = 0;
        if (varA > varB) {
            comparison = 1;
        } else if (varA < varB) {
            comparison = -1;
        }
        return (
            (order == 'desc') ? (comparison * -1) : comparison
        );
    };
}

}
